var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.001 10H13.001V15H11.001V10ZM11 16H13V18H11V16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.768 4.19994C13.42 3.54494 12.742 3.13794 12 3.13794C11.258 3.13794 10.58 3.54494 10.232 4.20094L2.89401 18.0639C2.73118 18.3684 2.65052 18.71 2.65999 19.0551C2.66946 19.4002 2.76873 19.7369 2.94801 20.0319C3.12471 20.3283 3.37565 20.5735 3.67606 20.7432C3.97647 20.913 4.31596 21.0015 4.66101 20.9999H19.339C20.047 20.9999 20.688 20.6379 21.053 20.0319C21.232 19.7368 21.3311 19.4001 21.3406 19.0551C21.35 18.71 21.2696 18.3685 21.107 18.0639L13.768 4.19994ZM4.66101 18.9999L12 5.13694L19.344 18.9999H4.66101Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxError);
export default __webpack_public_path__ + "static/media/bx-error.b2b0b1eedf0f5048bcef65b98fd0ffac.svg";
export { ForwardRef as ReactComponent };